import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    IEntityLeaderboardParams,
    INewEntityLeaderboardData,
    IWeightedScoreData,
} from '../interfaces/performance-entity-data';

@Injectable({
    providedIn: 'root',
})
export class EntityLeaderboardService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/EntityLeaderboard/').replace(
        '{version}',
        this.version
    );

    constructor(private _http: HttpClient) {}

    // TODO: Probably these two API calls get the exact same data.
    // investigate those and remove any duplication along the pipeline
    getNewEntityLeaderboardData(params: IEntityLeaderboardParams) {
        return this._http.post<INewEntityLeaderboardData[]>(
            this._url + 'GetNewEntityLeaderboardData',
            params,
            {
                headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            }
        );
    }

    getEntityWeightedScore(params: IEntityLeaderboardParams) {
        return this._http.post<IWeightedScoreData[]>(this._url + 'GetEntityWeightedScore', params, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }
}
